import { Grid, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { EquipmentType } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { OperationalEquipmentAssignmentActions } from '../atoms/OperationalEquipmentAssignmentActions'

interface Props {
  equipmentType?: EquipmentType
  equipmentCount: number
  assignmentsTotal: number
  canAddAssignment: boolean
  assignmentType: string
  onAdd: () => void
  onRemove: () => void
}
export const OperationalEquipmentSharedAssignment = observer(
  ({
    equipmentType,
    equipmentCount,
    assignmentsTotal,
    canAddAssignment,
    assignmentType,
    onAdd,
    onRemove,
  }: Props) => {
    const theme = useMinimalsTheme()
    const { t } = useTranslate()

    if (!assignmentsTotal || equipmentCount === 1) return <></>

    return (
      <>
        <Grid size={10}>
          <Stack
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              padding: theme.customSpacing.s,
              width: '100%',
              backgroundColor: theme.palette.grey[100],
              borderRadius: theme.customSpacing.s,
            }}
          >
            <Typography variant='body1' color='secondary'>
              {t(
                'currentAssignmentForTypeAssignedAcrossEquipment',
                'Current assignment: {assignmentsTotal} {assignmentType} assigned across {equipmentCount} {equipmentType}s',
                {
                  assignmentType: assignmentType,
                  assignmentsTotal: assignmentsTotal,
                  equipmentCount: equipmentCount,
                  equipmentType: equipmentType,
                },
              )}
            </Typography>
          </Stack>
        </Grid>
        <OperationalEquipmentAssignmentActions
          canAddAssignment={canAddAssignment}
          onAdd={onAdd}
          onRemove={onRemove}
        />
      </>
    )
  },
)
